import { parseId } from './postingModule';

const candidateTemplate = (data = {}) => ({
    id: data.id,

    cv: data.cv,
    degrees: data && data.degrees ? data.degrees.map(degreeTemplate) : [],
    languages:
        data && data.languages ? data.languages.map(languageTemplate) : [],

    linkedin: data.linkedin,
    github: data.github,

    skills: data && data.skills ? data.skills : [], // TODO: Make proper template
    interests: data && data.interests ? data.interests : [], // TODO: Make proper template
    tests: data && data.tests ? data.tests : [], // TODO: Make proper template
});

const degreeTemplate = (data = {}) => ({
    id: data.id,
    candidate_id: data.candidate_id,
    created_at: data.created_at,

    school_id: data.school_id,
    school: data && data.school ? schoolTemplate(data.school) : undefined,

    field_id: data.field_id,
    level_id: data.level_id,
    field: data.field,
    level: data.level,

    name: data.name,
    description: data.description,
    documents: data.documents || [],

    start: data.start,
    end: data.end,
});

const languageTemplate = (data = {}) => ({
    id: data.id,
    created_at: data.created_at,
    candidate_id: data.candidate_id,
    languageId: data.language && data.language.id,
    language: data.language && data.language.name,
    proficiencyId: data.proficiency && data.proficiency.id,
    proficiency: data.proficiency && data.proficiency.level,
});

const schoolTemplate = (data = {}) => ({
    id: data.id,
    created_at: data.created_at,
    logo: data.logo,
    name: data.name,
});

const languageInfoTemplate = (data = {}) => ({
    languages:
        data.languages instanceof Array
            ? data.languages.map(lang => ({ id: lang.id, name: lang.name }))
            : [],
    proficiencies:
        data.proficiencies instanceof Array
            ? data.proficiencies.map(prof => ({
                  id: prof.id,
                  level: prof.level,
              }))
            : [],
});

export const favoriteTemplate = (data = {}) => {
    const favorite = {
        id: data.id,
        createdAt: data.created_at,
        updatedAt: data.updated_at,
        postingExpireTime: data.postingExpireTime,

        candidateId: data.candidate_id,
        jobAdId: data.jobAdId,
    };

    if (data.job) {
        favorite.job = {
            id: parseId(data.job.jobName),
            jobAdId: data.job.jobId,
            title: data.job.title,
            companyId: data.job.companyId,
            companyLogo: data.job.companyLogo,
            companyName: data.job.companyName,
            deadline: data.job.postingExpireTime,
            address: data.job.address,
        };
    }
    return favorite;
};

export default {
    template: ['CANDIDATE_TEMPLATE', candidateTemplate],
    authorize: true,

    '/me': {
        GET: {},
    },

    '/language': {
        template: ['LANGUAGE_TEMPLATE', languageTemplate],
        POST: {},

        '/:id': {
            PUT: {},
            DELETE: {},
        },
    },

    // Get all available languages and proficiencies in the system
    '/languages': {
        template: ['LANGUAGES_TEMPLATE', languageInfoTemplate],
        GET: {},
    },

    '/degree': {
        template: ['DEGREE_TEMPLATE', degreeTemplate],
        POST: {},

        '/:id': {
            PUT: {},
            DELETE: {},
        },
    },

    '/school': {
        template: ['SCHOOL_TEMPLATE', schoolTemplate],
        POST: {},
        GET: {},
    },

    '/favorite': {
        template: ['FAVORITE_TEMPLATE', data => ({ id: 1, ...data })],
        authorize: true,
        POST: {},
        GET: {},

        '/:id': {
            template: ['FAVORITE_TEMPLATE', favoriteTemplate],
            DELETE: {},
            GET: {},
        },
    },

    '/test': {
        template: [
            'TEST_TEMPLATE',
            data => ({
                id: data.id,
                hasBeta: data.beta,
                cuteTestId: data.cuteTestId,
            }),
        ],
        GET: {},

        '/cut-e': {
            template: [
                'CUT-E-TEMPLATE',
                data => ({
                    id: data.id,
                    cuteId: data.cuteId,
                    key: data.key,
                    link: data.link,
                    consented: data.consented,
                    statuses: (data.testStatuses || []).map(status => ({
                        id: status.id,
                        status: status.status,
                    })),
                }),
            ],
            GET: {},
            PUT: {},
        },
    },
};
